import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=c9a58e2a&"
import script from "./reply.vue?vue&type=script&lang=ts&"
export * from "./reply.vue?vue&type=script&lang=ts&"
import style0 from "./reply.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports